<template>
  <div class="container">
    <h1 class="h1">Audit Logs <span
        style="font-size: x-small">max 100</span></h1>
    <sdx-loading-spinner id="spinner-auditLogs" ref="spinnerAuditLogs" size="large"
                         sr-hint="Loading. Please wait."></sdx-loading-spinner>
    <div id="audit-logs" ref="auditLogs">
      <div class="audit-logs-table table table--responsive table--highlight margin-v-2">
        <div class="table-wrapper">
          <table data-init="auto">
            <thead>
            <tr>
              <th class="table-header">User</th>
              <th class="table-header">Asset</th>
              <th class="table-header">Action</th>
              <th class="table-header">CreatedOn</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="item in auditLogs" v-bind:key="item">
              <td class="cell-top">{{ item.user }}</td>
              <td class="cell-top">{{ item.asset }}</td>
              <td class="wrapTd">{{ item.action }}</td>
              <td class="cell-top">{{ formatDate(item.createdOn) }}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import auditLogsService from '../service'
import loadingSpinnerService from "@/services/loading-spinner.service";
import {formatDate} from "@/util/utility";

export default {
  data: function () {
    return {
      auditLogs: [],
    }
  },
  mounted() {
    this.loadAuditLogs()
  },
  methods: {
    formatDate,
    loadAuditLogs: async function () {
      loadingSpinnerService.showByRef(this.$refs.spinnerAuditLogs, this.$refs.auditLogs)
      let response = await auditLogsService.getAudits();
      this.auditLogs = response.data;
      loadingSpinnerService.hideByRef(this.$refs.spinnerAuditLogs, this.$refs.auditLogs)
    }
  }
}
</script>

<style>

.audit-logs-table.table tbody td {
  padding-top: 5px;
  padding-bottom: 3px;
}

.cell-top{
  vertical-align: top !important;
}

.wrapTd{
  white-space: break-spaces !important;
}
</style>